import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000'

// Create a configured axios instance
const server = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/vnd.api+json'
  }
})

// Get client and server version info
const getVersions = () => {
  const clientUpdatedAt = process.env.REACT_APP_UPDATED_AT || 'N/A'
  return new Promise((resolve, reject) => {
    server.get('/')
    .then(result => resolve({
      clientUpdatedAt: clientUpdatedAt,
      serverUpdatedAt: result.data.data.attributes.updatedAt
    }))
    .catch(error => reject(error))
  })
}

export default getVersions



// WEBPACK FOOTER //
// ./src/stores/version.js